<script setup lang="ts">
/**
 * Lightweight upgrade prompt: sentence + "Upgrade" link + black star.
 * Used on the free dashboard where only the consolidation card carries the primary CTA.
 */
defineProps<{
  message: string
}>()

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <p class="sa-upgrade-inline">
    {{ message }}
    <button type="button" class="sa-upgrade-inline__link" @click="emit('upgrade')">
      {{ $t('Dashboard.Home.UpgradeLink') }}
    </button>
    <span class="sa-upgrade-inline__star sa-upgrade-inline__star--after" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <polygon
          points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        />
      </svg>
    </span>
  </p>
</template>
